export * from './partner-list/partner-list.component';
export * from './partner-add/partner-add.component';
export * from './partner-edit/partner-edit.component';
